import { render, staticRenderFns } from "./FormCollaboration.vue?vue&type=template&id=54cef227&"
import script from "./FormCollaboration.vue?vue&type=script&lang=js&"
export * from "./FormCollaboration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports